import {
	ActivityIndicator,
	SafeAreaView,
	StyleSheet,
	Text,
	TouchableOpacity,
	View,
} from "react-native";
import React, { useEffect, useState } from "react";
import { WebView } from "react-native-webview";
import Feather from "@expo/vector-icons/Feather";
import { HomeScreenProps } from "./HomeStack";
import { SignInWebViewScreenProps } from "./HomeStack";

const SignInWebView = ({ navigation, route }: SignInWebViewScreenProps) => {
	const [prog, setProg] = useState(false);
	const [loading, setLoading] = useState(true);
	const [progClr, setProgClr] = useState("#000");

	const uri = route.params?.delete
		? "https://www.4schools.io/sign-in"
		: "https://www.4schools.io/privacy-policy";
	return (
		<SafeAreaView style={{ flex: 1 }}>
			<View style={styles.wbHead}>
				<TouchableOpacity
					style={{ padding: 13 }}
					onPress={() => navigation.navigate("Settings")}
				>
					<Feather name={"x"} size={24} />
				</TouchableOpacity>
				<Text
					style={{
						flex: 1,
						textAlign: "center",
						fontSize: 16,
						fontWeight: "bold",
						color: "#00457C",
					}}
				>
					ISIC
				</Text>
				<View style={{ padding: 13, opacity: prog ? 1 : 0 }}>
					<ActivityIndicator size={24} color={progClr} />
				</View>
			</View>
			{!loading ? (
				<WebView
					source={{ uri: uri }}
					androidLayerType="hardware"
					style={{ flex: 1 }}
					onLoadStart={() => {
						setProg(true);
						setProgClr("#000");
					}}
					onLoadEnd={e => {
						setProg(false);
					}}
					onLoad={() => {
						setProg(false);
					}}
					onError={e => console.log(e)}
				/>
			) : (
				<WebView
					source={{ uri: uri }}
					androidLayerType="hardware"
					style={{ flex: 1 }}
					onLoadStart={() => {
						setProg(true);
						setProgClr("#000");
					}}
					onLoadEnd={e => {
						setProg(false);
					}}
					onLoad={() => {
						setProg(false);
					}}
					onError={e => console.log(e)}
				/>
			)}
		</SafeAreaView>
	);
};

export default SignInWebView;

const styles = StyleSheet.create({
	wbHead: {
		flexDirection: "row",
		alignItems: "center",
		backgroundColor: "#f9f9f9",
		zIndex: 25,
		elevation: 2,
	},
});
